import React, { useMemo } from 'react';

import { INTERNAL_LINKS } from '../../../enum';
import useDebouncedState from '../../../hooks/useDebouncedState';
import useDidUpdateEffect from '../../../hooks/useDidUpdateEffect';
import { checkIfStringContainsValue, getUserFullName, momentFormat } from '../../../utils/common';
import ProfileNamePicture from '../../shared-ui/ProfileNamePicture';
import CustomTable from '../../Table';
import StatusTag from '../../Tag/StatusTag';

const UserInRateTable = props => {
  const { t, dataSource, onSearch, ...rest } = props;

  const [searchTerm, setSearchTerm] = useDebouncedState();

  useDidUpdateEffect(() => {
    if (typeof onSearch === 'function') {
      onSearch(searchTerm);
    }
  }, [searchTerm]);

  const filteredDataSource = useMemo(() => {
    let array = [...dataSource];

    if (searchTerm) {
      array = array.filter(user => {
        return (
          checkIfStringContainsValue(getUserFullName(user), searchTerm) ||
          checkIfStringContainsValue(
            user.dateAddedToGroup ? momentFormat(user.dateAddedToGroup, 'YYYY-MM-DD') : '-',
            searchTerm,
          )
        );
      });
    }

    return array;
  }, [searchTerm, dataSource]);

  const COLUMNS = [
    {
      title: t('name'),
      key: ['firstName', 'lastName'].join(','),
      defaultSortOrder: 'ascend',
      render: (actions, data) => (
        <ProfileNamePicture
          t={t}
          showStatus={false}
          user={data}
          redirectTo={`${INTERNAL_LINKS.USER_DETAILS_PROFILE(data._id)}`}
        />
      ),
      sorter: true,
    },
    {
      key: 'status',
      title: t('Status'),
      render: (actions, data) => <StatusTag status={data.status} />,
      sorter: true,
    },
    {
      title: t('effectiveDate'),
      dataIndex: 'additionDate',
      render: additionDate => (additionDate ? momentFormat(additionDate, 'YYYY-MM-DD') : '-'),
    },
  ];

  return (
    <CustomTable
      {...rest}
      columns={COLUMNS}
      dataSource={filteredDataSource}
      onSearchTermChange={setSearchTerm}
    />
  );
};

export default UserInRateTable;
